import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

type Align = "left" | "center" | "right";

interface Slide {
  title: string;
  subtitle: string;
  align: Align;
}

const slides: Slide[] = [
  {
    title: "Elegansi Muslimah Modern",
    subtitle: "Koleksi busana muslim eksklusif dari HIJAFERA untuk tampilan anggun setiap hari.",
    align: "left",
  },
  {
    title: "Tampil Syar'i & Stylish",
    subtitle: "Perpaduan desain minimalis dan kenyamanan untuk aktivitas harian muslimah.",
    align: "center",
  },
  {
    title: "Koleksi Terbaru HIJAFERA",
    subtitle: "Temukan gamis, hijab, dan outfit muslim terbaik dengan kualitas premium.",
    align: "right",
  },
];

const gradients = ["linear-gradient(135deg,#4a1e19cc 0%,#7c3a14cc 40%,#f0aa17cc 100%)", "linear-gradient(135deg,#1e1b4bcc 0%,#4a1e94cc 40%,#7c3aedcc 100%)"];

const Hero = () => {
  const [index, setIndex] = useState(0);
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(false);

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % slides.length);
        setAnimate(true);
      }, 300);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const slide = slides[index];

  const alignment: Record<Align, string> = {
    right: "justify-end text-right",
    left: "justify-start text-left",
    center: "justify-center text-center",
  };

  return (
    <section className="relative min-h-screen flex items-center text-white overflow-hidden">
      {/* BACKGROUND IMAGE */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-35"
        style={{
          backgroundImage: "url('/images/bg-hijafera.png')",
        }}
      />

      {/* GRADIENT OVERLAY */}
      <div
        className="absolute inset-0 transition-all duration-1000"
        style={{
          background: gradients[index % gradients.length],
        }}
      />

      {/* CONTENT */}
      <div className={`relative max-w-7xl mx-auto px-6 pt-24 pb-12 w-full flex ${alignment[slide.align]}`}>
        <div className={`max-w-xl transition-all duration-700 ${animate ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <p className="uppercase tracking-[0.35em] text-sm opacity-80">HIJAFERA COLLECTION</p>

          <h1 className="text-5xl md:text-7xl font-bold mt-4 leading-tight">{slide.title}</h1>

          <p className="mt-6 text-lg text-white/90">{slide.subtitle}</p>

          <Link to="/produk">
            <button className="mt-8 bg-white text-[#4a1e19] font-semibold px-7 py-3 rounded-lg hover:bg-gray-200 transition">Shop Now</button>
          </Link>
        </div>
      </div>

      {/* indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex gap-3">
        {slides.map((_, i) => (
          <div key={i} className={`h-[4px] w-16 rounded-full transition-all duration-500 ${i === index ? "bg-white" : "bg-white/40"}`} />
        ))}
      </div>
    </section>
  );
};

export default Hero;
